module.exports = __webpack_public_path__ + "img/btn-start.ca879af9.png";